module.exports = __webpack_public_path__ + "media/application/images/news/secondary_nav/published-papers-500cec98ef4306838e01f967ed6a67df.jpg";